/**
 * @file index.tsx
 *
 * @fileoverview A component that hides its contents on mobile.
 */
import React from "react";
import styles from "../visibility.module.scss";

interface HideMobileProps {
  /**
   * The contents to hide on mobile.
   */
  children: React.ReactNode;
  /**
   * An optional class name to apply to the component.
   */
  className?: string;
}

/**
 * The component will hide its contents when viewed on a small device.
 * The width for the breakpoint is defined in the theme object.
 */
export function HideMobile({ children, className = "" }: HideMobileProps) {
  return <div className={`${styles.hideMobile} ${className}`}>{children}</div>;
}

export default HideMobile;
